/* esm.sh - rxjs@7.8.2/dist/esm/internal/Scheduler */
export * from "/*rxjs@7.8.2/esnext/dist/esm/internal/Scheduler.mjs";
